module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "view-auto-action-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                  " + _vm._s(_vm.title ? _vm.title : _vm.$t("booking.detail.messages.auto_action_modal_title")) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#view-auto-action-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    class: _vm.notificationLoading ? 'modal-body d-flex justify-content-center align-items-center' : 'modal-body',
    staticStyle: {
      "min-height": "300px"
    }
  }, [(_vm.notificationLoading) ? _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.notificationLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.notificationLoading) ? _c('div', [(_vm.autoActionContent.subject) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "auto-action-subject"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("input.subject")) + "\n                  ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "auto-action-subject"
    }
  }, [_vm._v(_vm._s(_vm.autoActionContent.subject))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "content-item"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "auto-action-message-content"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("input.message_content")) + "\n                  ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "auto-action-message-content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.autoActionContent.message || _vm.autoActionContent)
    }
  })])])])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ec2a6b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/bookings/details/modals/NotificationContentModal.vue
// module id = 1347
// module chunks = 0